import React from 'react'
import {
  GoogleMap,
  GoogleMapProps,
  useJsApiLoader,
} from '@react-google-maps/api'

import { mapContainerStyles, mapStyles } from './mapStyles'

export interface MapProps extends GoogleMapProps {
  children?: React.ReactNode
}

const Map: React.FC<MapProps> = ({
  children,
  center: propCenter,
  zoom = 8,
  options = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: true,
    scrollwheel: true,
    styles: mapStyles,
    disableDoubleClickZoom: true,
    clickableIcons: false,
    keyboardShortcuts: false,
    backgroundColor: '#f2f2f2',
    tilt: 0,
    heading: 0,
  },
  ...others
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyD9bSVM6soP2F2oAA7riyrBtXyiTXF2K0w',
  })

  const [center, setCenter] = React.useState<
    google.maps.LatLng | google.maps.LatLngLiteral
  >({
    lat: 51.990276,
    lng: 5.103033,
  })

  React.useEffect(() => {
    if (propCenter !== undefined) {
      setCenter(propCenter)
    }
  }, [propCenter])

  return isLoaded ? (
    <GoogleMap
      id="google-map"
      mapContainerStyle={mapContainerStyles}
      center={center}
      zoom={zoom}
      options={options}
      {...others}
    >
      {/* Child components, such as markers, info windows, etc. */}
      {children}
    </GoogleMap>
  ) : (
    <></>
  )
}

export default Map
